import View from './view.js'


class searchView extends View{
    _parentElement = document.querySelector('.search');


    getQuery()
    {
        return this._parentElement.querySelector('.search__field').value;
    }
    
    handleSearch(handler)
    {
        this._parentElement.addEventListener('submit' , function(e){
            e.preventDefault();
            handler();
            this._parentElement.querySelector('.search__field').value = '';
        }.bind(this))
    }

}

export default new searchView();